import { ElementRef, Injectable } from '@angular/core';
import { animate, AnimationBuilder, style } from '@angular/animations';

@Injectable({
    providedIn: 'root',
})
export class SplashScreenService {
    // Private properties
    private el: ElementRef;

    private stopped: boolean;

    private playerTimeout = 100;

    private animationTimeout = 800;

    /**
     * Service constructor
     *
     * @param animationBuilder: AnimationBuilder
     */
    constructor(private animationBuilder: AnimationBuilder) {}

    /**
     * Init
     *
     * @param element: ElementRef
     */
    init(element: ElementRef): void {
        this.el = element;
    }

    /**
     * Hide
     */
    hide(): void {
        if (this.stopped || !this.el) {
            return;
        }

        const player = this.animationBuilder
            .build([style({ opacity: '1' }), animate(this.animationTimeout, style({ opacity: '0' }))])
            .create(this.el.nativeElement);

        player.onDone(() => {
            if (typeof this.el.nativeElement.remove === 'function') {
                this.el.nativeElement.remove();
            } else {
                this.el.nativeElement.style.display = 'none !important';
            }
            this.stopped = true;
        });

        setTimeout(() => player.play(), this.playerTimeout);
    }
}
